import { render, staticRenderFns } from "./VRFinanicalAnalysis.vue?vue&type=template&id=940afb1a"
import script from "./VRFinanicalAnalysis.vue?vue&type=script&lang=js"
export * from "./VRFinanicalAnalysis.vue?vue&type=script&lang=js"
import style0 from "./VRFinanicalAnalysis.vue?vue&type=style&index=0&id=940afb1a&prod&scope=true&lang=css"
import style1 from "./VRFinanicalAnalysis.vue?vue&type=style&index=1&id=940afb1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports